import Image from 'next/image';
import styled from 'styled-components';

import { Copy, Link } from '@/components/elements';

export const StyledTestimonialWrapper = styled.figure`
  margin: 0;
`;

export const StyledHeader = styled.figcaption`
  display: flex;
  grid-gap: var(--distance-static-xs);
  align-items: center;

  margin: 0 0 var(--distance-static-l) 0;
`;

export const StyledLocation = styled(Copy)`
  color: var(--color-testimonials-secondary);
`;

export const StyledName = styled(Copy)`
  color: var(--color-testimonials-main);
`;

export const StyledImage = styled(Image)`
  border-radius: 50%;
`;

export const StyledRateWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: var(--distance-static-m);
`;

export const StyledLinkShowMore = styled(Link)`
  margin-left: var(--distance-static-xs);
`;

export const StyledBlockquote = styled.blockquote`
  margin: 0;
`;

export const StyledDescription = styled(Copy)`
  color: var(--color-testimonials-main);
`;

export const StyledPlaceholder = styled(Copy)<{ $index: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  background-color: ${({ $index }) =>
    `var(--color-testimonials-placeholder-${$index % 3})`};
  color: var(--color-text-light);
`;
